var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.148 1.496L4.895 4.75l3.253 3.254-.82.82L4.074 5.57.82 8.824 0 8.004 3.254 4.75 0 1.496l.82-.82L4.074 3.93 7.328.676l.82.82z"
  })));
}
export default SvgClose;